import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "../Micro/Button";
import Modal, { ModalContent } from "../Micro/Modal/Modal";
import StarRate from "../Micro/StarRate";
import { toast } from "sonner";
import { handleRequestError, post } from "../../backend";
import useUser from "../../hooks/useUser";
import useLoading from "../../hooks/useLoading";

const Feedback = ({
  modal,
  setModal,
}: {
  modal: boolean;
  setModal: (by: boolean) => void;
}) => {
  const { user } = useUser();
  const { loading, start, stop } = useLoading();
  const [rating, setRating] = React.useState({
    rate: 0,
    color: "",
    hover: 0,
  });

  const handleFeedback = async (value: { feedback: string }) => {
    const painLevel =
      rating.rate >= 1 && rating.rate <= 2
        ? "High"
        : rating.rate >= 3 && rating.rate <= 4
          ? "Medium"
          : rating.rate === 5
            ? "Low"
            : "Unknown";

    try {
      start();
      await post(
        "https://productlane.com/api/v1/feedback",
        {
          text: value.feedback,
          email: user.email,
          painLevel: painLevel.toUpperCase(),
          notify: {
            email: true,
            slack: true,
          },
          origin: "API",
        },
        { Authorization: "Bearer pl_3ZLdsVfgVwPT28ftzjv6ZQYT" },
      );
      setModal(false);
      value.feedback = "";
      setRating({ ...rating, rate: 0 });
      toast.success("Feedback submitted");
    } catch (error: any) {
      handleRequestError(error);
    } finally {
      stop();
    }
  };

  const Formik = useFormik({
    initialValues: {
      feedback: "",
    },
    onSubmit: handleFeedback,
    validationSchema: Yup.object({
      feedback: Yup.string().required(
        "Please note that your feedback is important to us...",
      ),
    }),
  });
  return (
    <Modal open={modal} onClose={() => setModal(false)} className="min-w-full">
      <ModalContent className="dark:bg flex flex-col items-center justify-center overflow-y-auto rounded-xl bg-white p-5">
        <div className="flex w-full flex-col items-center justify-center">
          <div className="w-full max-w-sm space-y-4 rounded-md px-10 py-5 pt-8 shadow-custom dark:shadow-dark-mode">
            <div className="flex w-full flex-col space-y-4">
              <p className="-mb-3 text-sm sm:text-lg">
                How was your experience?
              </p>
              <span className="text-xs text-gray-500">
                Your input is valuable in helping us better understand your
                needs to give you best experience possible.
              </span>
              <StarRate rating={rating} setRating={setRating} />
              <div className="flex items-center justify-between text-xs text-[#9e9f9e]">
                <p>Terrible</p>
                <p>Great</p>
              </div>
            </div>
          </div>
          {rating.rate > 0 && (
            <div className="w-full max-w-sm pt-8">
              <form
                onSubmit={Formik.handleSubmit}
                className="w-full rounded-md shadow-custom dark:shadow-dark-mode"
              >
                <div className="p-5">
                  <p className="text-sm font-bold">
                    Do you have any thoughts you&apos;d like to share?
                  </p>
                  <p className="py-1 text-sm text-red-600">
                    {Formik.errors.feedback &&
                      Formik.touched.feedback &&
                      Formik.errors.feedback}
                  </p>
                  <textarea
                    className="h-36 w-full rounded-lg border border-none bg-light2 p-5 text-sm disabled:bg-light/50 disabled:dark:bg-theme-color/50"
                    placeholder="Add a comment..."
                    name="feedback"
                    value={Formik.values.feedback}
                    onChange={Formik.handleChange}
                    onBlur={Formik.handleBlur}
                  />
                </div>
                <div className="flex w-full justify-center bg-[#D9D9D91F] py-3 dark:bg-theme-color-light">
                  <Button className="h-7 w-[135px]" loading={!!loading}>
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          )}
        </div>
      </ModalContent>
    </Modal>
  );
};

export default Feedback;
